import { render, staticRenderFns } from "./applyConfirmAudit.vue?vue&type=template&id=704b54e4&scoped=true"
import script from "./applyConfirmAudit.vue?vue&type=script&lang=js"
export * from "./applyConfirmAudit.vue?vue&type=script&lang=js"
import style0 from "./applyConfirmAudit.vue?vue&type=style&index=0&id=704b54e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b54e4",
  null
  
)

export default component.exports